<template>
    <transition name="fade" mode="out-in">
        <Spinner v-if="isLoading" />
        <div v-else>
            <LotteryResultToday
                :result="result"
                @switch-region="switchRegion"
            />
        </div>
    </transition>
</template>

<script>
import LotteryResultToday from '@/components/Home/LotteryResultToday';
import Spinner from '@/components/common/Spinner/Spinner';
import resultService from '@common/services/result.service';
import { mapGetters, mapActions } from 'vuex';
import * as params from '@/utils/urlParams';

export default {
    components: {
        LotteryResultToday,
        Spinner,
    },
    data() {
        return {
            isLoading: true,
            result: null,
        };
    },
    methods: {
        ...mapActions({
            fetchStartDate: 'userModule/fetchStartDate',
        }),
        convertRegionToVi(region) {
            return params.REGION.VI[region.toUpperCase()];
        },
        switchRegion(region) {
            switch (region) {
                case params.REGION.EN.ALL:
                    this.getAllResult();
                    break;
                default:
                    this.getResultByRegion(region);
                    break;
            }
        },
        async getResultByRegion(region) {
            await this.fetchStartDate();
            const resultDefault = [
                {
                    name: params.REGION.EN.NORTH,
                    data: [],
                },
                {
                    name: params.REGION.EN.CENTRAL,
                    data: [],
                },
                {
                    name: params.REGION.EN.SOUTH,
                    data: [],
                },
            ];

            resultService
                .getResultData(
                    this.convertRegionToVi(region),
                    this.startDate,
                    {},
                )
                .then(res => {
                    const regionIndex = item => item.name == region;
                    resultDefault[resultDefault.findIndex(regionIndex)].data =
                        res.data.rows;
                    this.result = resultDefault;
                })
                .catch(e => {
                    console.log(e);
                });
        },
        async getAllResult() {
            await this.fetchStartDate();
            const getResultNorth = new Promise((resolve, reject) => {
                resultService
                    .getResultData(params.REGION.VI.NORTH, this.startDate)
                    .then(res => {
                        resolve(res);
                    })
                    .catch(e => {
                        reject(e);
                        console.log(e);
                    });
            });

            const getResultCentral = new Promise((resolve, reject) => {
                resultService
                    .getResultData(params.REGION.VI.CENTRAL, this.startDate)
                    .then(res => {
                        resolve(res);
                    })
                    .catch(e => {
                        reject(e);
                        console.log(e);
                    });
            });

            const getResultSouth = new Promise((resolve, reject) => {
                resultService
                    .getResultData(params.REGION.VI.SOUTH, this.startDate)
                    .then(res => {
                        resolve(res);
                    })
                    .catch(e => {
                        reject(e);
                        console.log(e);
                    });
            });

            Promise.all([
                getResultNorth,
                getResultCentral,
                getResultSouth,
            ]).then(values => {
                const [resultNorth, resultCentral, resultSouth] = values;
                this.result = [
                    {
                        name: params.REGION.EN.NORTH,
                        data: resultNorth.data.rows,
                    },
                    {
                        name: params.REGION.EN.CENTRAL,
                        data: resultCentral.data.rows,
                    },
                    {
                        name: params.REGION.EN.SOUTH,
                        data: resultSouth.data.rows,
                    },
                ];
                this.isLoading = false;
            });
        },
    },
    async created() {
        this.getAllResult();
    },
    computed: {
        ...mapGetters({
            startDate: 'userModule/startDate',
        }),
    },
};
</script>
